import type { FixedLineItem } from '@weft/types';
import VyDialog from 'apps/app/src/components/new-design/feedback/VyDialog';
import { useDeleteLineItem } from 'apps/app/src/hooks/requests/use-delete-line-item';
import { runMutation } from 'apps/app/src/utils/vy-mutation';
import React from 'react';
import { useQueryClient } from 'react-query';

type DeleteLineItemDialogProps = {
  open: boolean;
  handleClose: () => void;
  lineItem: FixedLineItem;
  invoiceId: string;
  customerId: string;
};

export const DeleteLineItemDialog: React.FC<DeleteLineItemDialogProps> = ({ open, handleClose, lineItem, invoiceId, customerId }) => {
  const deleteLineItemMutation = useDeleteLineItem();

  const queryClient = useQueryClient();

  const handleDialogSubmit = async () => {
    await runMutation(
      deleteLineItemMutation,
      { lineItemId: lineItem.id },
      {
        pending: 'Deleting line item...',
        success: 'Line item deleted',
        error: 'Failed to delete line item',
      }, {
        onSuccess: async () => {
          await queryClient.invalidateQueries({
            predicate: query => [invoiceId, customerId].some(key => query.queryKey.includes(key) && query.queryKey.includes('dynamicInvoice')),
          });
        },
      });
    handleClose();
  };

  return (
    <VyDialog
      open={open}
      onClose={handleClose}
      label="Are you sure you want to delete this item?"
      labelDescription="This will permanently delete the item from this invoice."
      warningText="Once done, you will not be able to recover or resume these items"
      cancelButtonText="Cancel"
      ctaText="Delete item"
      onSubmit={handleDialogSubmit}
    />
  );
};